export default __webpack_public_path__ + "static/media/Demo Snippet.89cba68a.svg";